import { MatFormFieldDefaultOptions } from '@angular/material/form-field';

export const matRippleGlobalOptions = { disabled: true };
export const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = { floatLabel: 'auto', appearance: 'outline', subscriptSizing: 'dynamic' };
export const matCheckboxDefaultOptions = { color: 'primary' };
export const matRadioDefaultOptions = { color: 'primary' };
export const matSelectDefaultConfig = { hideSingleSelectionIndicator: true };
export const matTabsDefaultConfig = { stretchTabs: false,  alignTabs: 'start' };
export const matToggleDefaultConfig = { hideIcon: true };
